// extracted by mini-css-extract-plugin
export default {"Table":"request_Table__Qx-rA"};